import React, { useEffect, useRef, useState } from "react";
import { Input } from "@lightspeed/flame/Input";

const DiscountAccountField = ({ value, accountsList = [], onChange, onSelect, onEnter }) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const containerRef = useRef(null);
  const searchRef = useRef(null);
  const term = search.toLowerCase();
  const accounts = accountsList.filter((account) =>
    String(account.id ?? "").toLowerCase().includes(term) ||
    String(account.description ?? "").toLowerCase().includes(term)
  );

  useEffect(() => {
    if (!open) return;
    searchRef.current?.focus();
    const closeOutside = (event) => {
      if (!containerRef.current?.contains(event.target)) setOpen(false);
    };
    document.addEventListener("mousedown", closeOutside);
    return () => document.removeEventListener("mousedown", closeOutside);
  }, [open]);

  const selectAccount = (account) => {
    onSelect(account.id ?? "", account.description ?? "");
    setOpen(false);
    setSearch("");
  };

  return (
    <div ref={containerRef} style={{ position: "relative", display: "flex", alignItems: "center" }}>
      <Input
        className="input-wrapper-row-inputbox"
        type="text"
        size="small"
        aria-label="Account (Discount)"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        onKeyDown={(event) => event.key === "Enter" && onEnter()}
      />
      <button
        type="button"
        aria-label="Choose Account (Discount)"
        aria-expanded={open}
        style={{ marginLeft: 4, cursor: "pointer", fontSize: 16, border: 0, padding: 0, background: "transparent", color: "inherit" }}
        onClick={() => {
          setOpen((previous) => !previous);
          setSearch("");
        }}
      >
        ▾
      </button>
      {open && (
        <div
          onKeyDown={(event) => {
            if (event.key === "Escape") setOpen(false);
          }}
          style={{
            position: "absolute", top: "100%", left: 0, background: "#fff",
            zIndex: 1000, boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
            border: "1px solid #ccc", borderRadius: 4, width: 450,
            minWidth: "100%", maxHeight: 200, overflowY: "auto", marginTop: 4,
          }}
        >
          <div style={{ padding: 4 }}>
            <input
              ref={searchRef}
              type="text"
              aria-label="Search discount accounts"
              placeholder="Search..."
              value={search}
              onChange={(event) => setSearch(event.target.value)}
              style={{ width: "100%", padding: 6, fontSize: 14, border: "1px solid #ccc", borderRadius: 4 }}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  event.preventDefault();
                  if (accounts[0]) selectAccount(accounts[0]);
                }
              }}
            />
          </div>
          {accounts.map((account) => (
            <button
              key={account.id}
              type="button"
              style={{ display: "block", width: "100%", textAlign: "left", padding: "6px 8px", cursor: "pointer", border: 0, borderBottom: "1px solid #eee", background: "#fff", color: "#111" }}
              onClick={() => selectAccount(account)}
            >
              <strong>{account.id}</strong> — {account.description}
            </button>
          ))}
          {accounts.length === 0 && (
            <div style={{ padding: "6px 8px", color: "#999" }}>No results</div>
          )}
        </div>
      )}
    </div>
  );
};

export default DiscountAccountField;
